import { useState } from 'react';
import { Modal, Select, Button } from 'antd';
import { useBuildingContext } from '../../context/BuildingContext';
import BuildingTag from '../BuildingTag';

interface BuildingIndicatorProps {
	style?: React.CSSProperties;
}

export default function BuildingIndicator({ style }: BuildingIndicatorProps) {
	const { buildingName, buildings, setBuildingId, buildingId } = useBuildingContext();
	const [modalOpen, setModalOpen] = useState(false);
	const [selectedId, setSelectedId] = useState<string | null>(null);

	if (!buildingName || buildings.length <= 1) return null;

	return (
		<>
			<BuildingTag
				name={buildingName}
				onClick={() => {
					setSelectedId(buildingId);
					setModalOpen(true);
				}}
				style={style}
			/>

			<Modal
				open={modalOpen}
				title="Change Building"
				onCancel={() => setModalOpen(false)}
				footer={null}
				centered
				width={400}
			>
				<Select
					style={{ width: '100%' }}
					size="large"
					value={selectedId}
					onChange={setSelectedId}
				>
					{buildings.map((b) => (
						<Select.Option key={b.id} value={b.id}>
							{b.name}
						</Select.Option>
					))}
				</Select>
				<Button
					type="primary"
					block
					style={{ marginTop: 16 }}
					disabled={!selectedId}
					onClick={() => {
						if (selectedId) {
							setBuildingId(selectedId);
							setModalOpen(false);
						}
					}}
				>
					Confirm
				</Button>
			</Modal>
		</>
	);
}
